const EXPERIMENT_EXPOSURE_FLAG_PREFIX = 'experiment_exposure_tracked_';

function markExperimentExposureTracked(experimentKey: string): void {
  try {
    sessionStorage.setItem(
      `${EXPERIMENT_EXPOSURE_FLAG_PREFIX}${experimentKey}`,
      'true'
    );
  } catch {
    // quota exceeded or unavailable in private browsing — fail silently
  }
}

function wasExperimentExposureTracked(experimentKey: string): boolean {
  try {
    return (
      sessionStorage.getItem(
        `${EXPERIMENT_EXPOSURE_FLAG_PREFIX}${experimentKey}`
      ) === 'true'
    );
  } catch {
    return false;
  }
}

export { markExperimentExposureTracked, wasExperimentExposureTracked };
